(function () {
  var sticky = document.querySelector('.sp-pdp-sticky-cart');
  if (!sticky || sticky.dataset.mobilePreviewBound === 'true') return;

  sticky.dataset.mobilePreviewBound = 'true';
  sticky.classList.add('smp-sticky');

  var buyButton = document.getElementById('rs-add-btn');
  var stickyButton = document.getElementById('rs-sticky-add');
  var footer = null;
  var frame = 0;
  var whatsappHost = null;
  var whatsappStyle = null;

  function repairRatingLink() {
    var ratingLink = document.querySelector('#sauna-pdp-v3 .rev-link[href="#testimonials"]');
    if (
      ratingLink &&
      !document.getElementById('testimonials') &&
      document.getElementById('reviews')
    ) {
      ratingLink.setAttribute('href', '#reviews');
    }
  }

  function modalIsOpen() {
    return Boolean(document.querySelector('cart-drawer[open], .drawer[active], dialog[open]'));
  }

  function wireWhatsApp() {
    var host = document.querySelector('gty-whatsapp-chat-button');
    if (!host || !host.shadowRoot) return null;

    whatsappHost = host;
    whatsappStyle = host.shadowRoot.getElementById('RecoverSaunaMobileWhatsAppPosition');
    if (!whatsappStyle) {
      whatsappStyle = document.createElement('style');
      whatsappStyle.id = 'RecoverSaunaMobileWhatsAppPosition';
      whatsappStyle.textContent =
        '@media(max-width:767px){:host(.sauna-purchase-active) .gty-wacb-wrapper{bottom:84px!important;transition:bottom .2s ease}}';
      host.shadowRoot.appendChild(whatsappStyle);
    }
    return host;
  }

  function sync() {
    frame = 0;
    var buyRect = buyButton ? buyButton.getBoundingClientRect() : null;
    var passedPurchase = Boolean(buyRect && buyRect.bottom < 0);
    if (!footer || !footer.isConnected) footer = document.querySelector('footer.footer-group');
    var footerRect = footer ? footer.getBoundingClientRect() : null;
    var footerVisible = Boolean(footerRect && footerRect.top < window.innerHeight && footerRect.bottom > 0);
    var active = passedPurchase && !footerVisible && !modalIsOpen();

    sticky.classList.toggle('smp-visible', active);
    sticky.setAttribute('aria-hidden', active ? 'false' : 'true');
    if (stickyButton) stickyButton.setAttribute('tabindex', active ? '0' : '-1');

    var host = wireWhatsApp();
    if (host) host.classList.toggle('sauna-purchase-active', active);
  }

  function scheduleSync() {
    if (frame) return;
    frame = window.requestAnimationFrame(sync);
  }

  window.addEventListener('scroll', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync);

  var observer = new MutationObserver(scheduleSync);
  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open', 'active'],
  });

  [0, 500, 1500, 3000].forEach(function (delay) {
    window.setTimeout(scheduleSync, delay);
  });

  repairRatingLink();

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target && event.target.contains(sticky)) {
      window.removeEventListener('scroll', scheduleSync);
      window.removeEventListener('resize', scheduleSync);
      observer.disconnect();
      if (frame) window.cancelAnimationFrame(frame);
      if (whatsappHost) whatsappHost.classList.remove('sauna-purchase-active');
      if (whatsappStyle) whatsappStyle.remove();
    }
  });

  sync();
})();
